export enum AssetModel3DScale {
    horizontal = 'horizontal',
    vertical = 'vertical',
    both = 'both',
}
